import { createReducer, on } from '@ngrx/store';
import {
  CloseUpdateDialog,
  OpenUpdateTagDialog,
  UpdateTagLabelChanged,
  UserSubmitted,
} from '../actions/update-tag.actions';

export interface UpdateTag {
  id: string;
  updateTagType: string;
  updateTagCode: string;
  updateTagLabel: string;
  userSubmitted: boolean;
}

const initialState: UpdateTag = {
  id: '',
  updateTagType: '',
  updateTagCode: '',
  updateTagLabel: '',
  userSubmitted: false,
};

export const UpdateTagReducer = createReducer(
  initialState,
  on(OpenUpdateTagDialog, (state, { row }) => ({
    ...state,
    id: row.id,
    updateTagType: row.tagType,
    updateTagCode: row.tagCode,
    updateTagLabel: row.tagLabel,
  })),
  on(UpdateTagLabelChanged, (state, { updateTagLabel }) => ({
    ...state,
    updateTagLabel,
  })),
  on(UserSubmitted, (state) => ({
    ...state,
    userSubmitted: true,
  })),
  on(CloseUpdateDialog, () => initialState),
);
